import { ProjectNanoID } from '../projects/projectsTypes';
import { FileAttachmentID } from '../fileAttachments/fileAttachmentsTypes';

export class DeepArchiveRestoreRequestCache {
  static fileAttachmentDeepArchiveRestoreRequestsCacheKey(
    fileAttachmentId: FileAttachmentID
  ) {
    return `file-attachment-${fileAttachmentId}-deep-archive-restore-requests`;
  }

  static projectDeepArchiveRestoreRequestsCacheKey(
    projectNanoId: ProjectNanoID
  ) {
    return `project-${projectNanoId}-deep-archive-restore-requests`;
  }
}
